import { ALTERA_COR_REQUEST, ALTERA_COR_SUCCESS } from './constants';

export function alterarCorSistemaRequest(values) {
  return {
    type: ALTERA_COR_REQUEST,
    values,
  };
}

export function alterarCorSistemaSuccess(values) {
  return {
    type: ALTERA_COR_SUCCESS,
    values,
  };
}
